"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var SupplierAgreementUpdateDTO_1 = require("../../supply/model/SupplierAgreementUpdateDTO");

var WindowItemUpdateDTO_1 = require("../../window/model/WindowItemUpdateDTO");

var ReplenishmentPromoManagementUpdateDTO_1 = require("../model/ReplenishmentPromoManagementUpdateDTO");

var ReplenishmentPromoManagementUpdateDTOConverter_1 = require("./ReplenishmentPromoManagementUpdateDTOConverter");

var ReplenishmentPromoManagementUpdateDTOConverterImpl =
/*#__PURE__*/
function (_ReplenishmentPromoMa) {
  _inherits(ReplenishmentPromoManagementUpdateDTOConverterImpl, _ReplenishmentPromoMa);

  function ReplenishmentPromoManagementUpdateDTOConverterImpl() {
    _classCallCheck(this, ReplenishmentPromoManagementUpdateDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementUpdateDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ReplenishmentPromoManagementUpdateDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ReplenishmentPromoManagementUpdateDTO_1.ReplenishmentPromoManagementUpdateDTO(ReplenishmentPromoManagementUpdateDTO_1.ReplenishmentPromoManagementUpdateDTO.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), ReplenishmentPromoManagementUpdateDTO_1.ReplenishmentPromoManagementUpdateDTO.schema.supplierAgreementId.valueOf(conversions.toClassReferenceId(source.supplierAgreementId)), this.valueOrUndefined(source, 'returnable'), this.valueOrUndefined(source, 'returnableCondition'), this.valueOrUndefined(source, 'endDateOfReturn', conversions.toDate), this.valueOrUndefined(source, 'ignoreForTraining'), this.valueOrUndefined(source, 'logisticComment'), this.valueOrUndefined(source, 'justInTime'), this.valueOrUndefined(source, 'lockType'), this.valueOrUndefined(source, 'selloutSales'), this.valueOrUndefined(source, 'directDelivery'), this.valueOrUndefined(source, 'directDeliverySites'), this.valueOrUndefined(source, 'distrModelId', conversions.toClassReferenceId), this.valueOrUndefined(source, 'distributionModelDays'), this.valueOrUndefined(source, 'maximalVolume', conversions.toBigNumber), this.valueOrUndefined(source, 'minimalVolume', conversions.toBigNumber), this.valueOrUndefined(source, 'obligatoryToBuy'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        supplierAgreementId: conversions.toDocumentReferenceId(source.supplierAgreementId)
      });
      this.assignIfDefined(result, source, 'returnable');
      this.assignIfDefined(result, source, 'returnableCondition');
      this.assignIfDefined(result, source, 'endDateOfReturn', conversions.fromDate);
      this.assignIfDefined(result, source, 'ignoreForTraining');
      this.assignIfDefined(result, source, 'logisticComment');
      this.assignIfDefined(result, source, 'obligatoryToBuy');
      this.assignIfDefined(result, source, 'maximalVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'minimalVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'justInTime');
      this.assignIfDefined(result, source, 'lockType');
      this.assignIfDefined(result, source, 'selloutSales');
      this.assignIfDefined(result, source, 'directDelivery');
      this.assignIfDefined(result, source, 'directDeliverySites');
      this.assignIfDefined(result, source, 'distrModelId', conversions.toDocumentReferenceId);
      this.assignIfDefined(result, source, 'distributionModelDays');
      return result;
    }
    /** @inheritDoc */

  }, {
    key: "toWindowItemUpdateDto",
    value: function toWindowItemUpdateDto(dto) {
      return new WindowItemUpdateDTO_1.WindowItemUpdateDTO(dto.windowItemId).copyMulti({
        returnable: dto.returnable,
        returnableCondition: dto.returnableCondition,
        endDateOfReturn: dto.endDateOfReturn,
        ignoreForTraining: dto.ignoreForTraining,
        logisticComment: dto.logisticComment,
        justInTime: dto.justInTime,
        lockType: dto.lockType,
        selloutSales: dto.selloutSales,
        directDelivery: dto.directDelivery,
        directDeliverySites: dto.directDeliverySites,
        distrModelId: dto.distrModelId,
        distributionModelDays: dto.distributionModelDays
      });
    }
    /** @inheritDoc */

  }, {
    key: "toSupplierAgreementUpdateDto",
    value: function toSupplierAgreementUpdateDto(dto) {
      return new SupplierAgreementUpdateDTO_1.SupplierAgreementUpdateDTO(dto.supplierAgreementId).copyMulti({
        maximalVolume: dto.maximalVolume,
        minimalVolume: dto.minimalVolume,
        obligatoryToBuy: dto.obligatoryToBuy
      });
    }
  }, {
    key: "valueOrUndefined",
    value: function valueOrUndefined(source, attribute, fn) {
      if (utils_1.Utils.isUndefined(source[attribute])) {
        return undefined;
      }

      if (utils_1.Utils.isNull(source[attribute])) {
        return null;
      }

      return fn ? ReplenishmentPromoManagementUpdateDTO_1.ReplenishmentPromoManagementUpdateDTO.schema[attribute].valueOf(fn(source[attribute])) : ReplenishmentPromoManagementUpdateDTO_1.ReplenishmentPromoManagementUpdateDTO.schema[attribute].valueOfField(source);
    }
  }, {
    key: "assignIfDefined",
    value: function assignIfDefined(obj, source, attribute, fn) {
      if (!utils_1.Utils.isUndefined(source[attribute])) {
        var srcObj = {};
        srcObj[attribute] = utils_1.Utils.isNull(source[attribute]) ? null : fn ? fn(source[attribute]) : source[attribute];
        Object.assign(obj, srcObj);
      }
    }
  }]);

  return ReplenishmentPromoManagementUpdateDTOConverterImpl;
}(ReplenishmentPromoManagementUpdateDTOConverter_1.ReplenishmentPromoManagementUpdateDTOConverter);

exports.ReplenishmentPromoManagementUpdateDTOConverterImpl = ReplenishmentPromoManagementUpdateDTOConverterImpl;